import { z } from 'zod';

import { BASE_SCHEMAS } from './base';

export const taxSettingsSchema = z.object({
  gstinNumber: BASE_SCHEMAS.gstin.optional(),
  cgstRate: z
    .number()
    .min(0, 'CGST must be 0 or greater')
    .max(100, 'CGST must be at most 100'),
  sgstRate: z
    .number()
    .min(0, 'SGST must be 0 or greater')
    .max(100, 'SGST must be at most 100'),
  serviceChargeRate: z
    .number()
    .min(0, 'Service charge must be 0 or greater')
    .max(100, 'Service charge must be at most 100'),
});

export type TaxSettingsFormData = z.infer<typeof taxSettingsSchema>;

export const taxSettingsDefaultValues: TaxSettingsFormData = {
  gstinNumber: '',
  cgstRate: 2.5,
  sgstRate: 2.5,
  serviceChargeRate: 5,
};
